export default __webpack_public_path__ + "static/nft_icon-556742f4853ee5543081b2b335583437.png";